import React from 'react';
import { Button } from '@framework-controls/core';
import { strings } from 'src/localization';
import css from './ServiceTabBtn.module.scss';
import classNames from 'classnames';
import { ServiceTabButtonIds } from 'src/enums';

interface IProps {
    id: ServiceTabButtonIds;
    label: string;
    selected: boolean;
    theme: string;
    onClick: (e: any) => void;
    colorSensitiveEnabled?: boolean;
}

/** Single sub-tab button for the ServiceTab view (Maintenance Menu / Individual Services / Write Your Own).
 *  Renders the button with theme-specific styling and a tooltip determined by the button's id. */
const ServiceTabBtn = (props: IProps) => {
    const btnClassName = classNames(
        css.calBtn,
        {
            [css.calBtnChecked]: props.selected,
            [css.calBtnCA]: props.theme === 'cadillac',
            [css.calBtnHonda]: props.theme === 'honda',
            [css.calBtnBuick]: props.theme === 'buick',
            [css.calBtnBMW]: props.theme === 'bmw' && !props.colorSensitiveEnabled,
            [css.calBtnBMWCS]: props.theme === 'bmw' && props.colorSensitiveEnabled,
            [css.calBtnFord]: props.theme === 'ford',
            [css.calBtnIN]: props.theme === 'infiniti',
            [css.calBtnMazda]: props.theme === 'mazda',
            [css.calBtnAcura]: props.theme === 'acura',
            [css.calBtnGenesis]: props.theme === 'genesis',
            [css.calBtnCS]: props.theme === 'colorSensitive' ||
                (props.colorSensitiveEnabled && props.theme !== 'buick' && props.theme !== 'bmw' && props.theme !== 'honda-CA'),
            [css.calBtnLexus]: props.theme === 'lexus',
        },
    );

    let tooltip = '';
    if (props.id === ServiceTabButtonIds.MaintMenu) {
        tooltip = strings.RecomMaintTip;
    }
    if (props.id === ServiceTabButtonIds.IndSvcs) {
        tooltip = strings.ViewServcTip;
    }
    if (props.id === ServiceTabButtonIds.WriteYour) {
        tooltip = strings.WriteYourOwnTip;
    }

    let label = props.label;
    if (props.theme === 'infiniti') {
        label = label.toLocaleLowerCase();
    }

    return (
        <div className={btnClassName}>
            <Button
                id={props.id + 'Btn'}
                onClick={props.onClick}
                variant='calBtn'
                disableRipple
                type={'text'}
                tooltip={tooltip}
            >
                <h3 className={css.calBtnContents}>{label}</h3>
            </Button>
        </div>
    );
};

export default ServiceTabBtn;